/* eslint-disable @typescript-eslint/no-explicit-any */
import { useChannelEventContext } from "@/common/provider/ChannelEventSocketProvider";
import styled from "styled-components";
import React from "react";
import { postReply } from "../../api/moimAPI";
import { GROUP_ID, MATCH_FORUM_ID, THREAD_ID } from "../../constant/group";
import { LOCAL_STORAGE_KEYS } from "../../constant/keys";
import { useCurrentUser } from "../../provider/currentUser";

const Wrapper = styled.div<{ width?: number; height?: number }>`
  width: 100%;
  height: 100%;
  overflow: hidden;
  iframe {
    width: 100%;
    height: 100%;
  }
`;

interface IProps {
  content: string;
  script: string[];
  css: string[];
  embedObject: Record<string, any>;
}

export default function IFrame({ content, script, css, embedObject }: IProps) {
  const postEvent = useChannelEventContext();
  const { currentUser } = useCurrentUser();
  const refComponentId = React.useRef<string>();
  const refHistoryChanged = React.useRef<boolean>(false);
  const [didInit, setDidInit] = React.useState(false);

  const ref = React.useRef<HTMLIFrameElement>(null);
  const [size, setSize] = React.useState<{
    width?: number;
    height?: number;
  }>({});
  const [cHTML, setHTML] = React.useState("");

  const accessToken = localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN);
  const refreshToken = localStorage.getItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN);
  const currentGroupId = GROUP_ID;

  const sharedObject =
    new URLSearchParams(location.search).get("sharedObject") ?? undefined;

  // const debounceSetSize = React.useCallback(
  //   debounce((params: { width?: number; height?: number }) => {
  //     setSize(params);
  //   }, 120),
  //   [],
  // );

  const recvMessage = React.useCallback((e: MessageEvent) => {
    switch (e.data.type) {
      case "EMBED_INIT_COMPONENT":
        refComponentId.current = e.data.payload.componentId;
        break;
      case "EMBED_INIT_SIZE":
      case "EMBED_RESIZE":
        if (e.data.componentId === refComponentId.current) {
          // debounceSetSize(e.data.payload);
          setSize(e.data.payload);
        }
        break;
      case "EMBED_REDIRECT": {
        if (e.data.componentId === refComponentId.current) {
          if (e.data.payload.location) {
            // redirect(e.data.payload.location);
          }
        }
        break;
      }
      case "EMBED_SWIPE_EVENT": {
        if (e.data.componentId === refComponentId.current) {
          document.dispatchEvent(
            new CustomEvent("swipeEvent", {
              detail: { direction: e.data.payload.direction },
            }),
          );
        }
        break;
      }
      case "REPLY_CREATE": {
        if (e.data.componentId === refComponentId.current) {
          const {
            channelId,
            parentId,
            content: payloadContent,
          } = e.data.payload;
          if (channelId && parentId && Boolean(payloadContent?.length)) {
            postReply(channelId, parentId, payloadContent)
              .then(newThread => {
                const newId = newThread.id;
                ref.current?.contentWindow?.postMessage(
                  {
                    type: "REPLY_CREATE_SUCCESS",
                    componentId: refComponentId.current,
                    passoverPayload: e.data.passoverPayload,
                    payload: { newId },
                  },
                  "*",
                );
              })
              .catch(() => {
                ref.current?.contentWindow?.postMessage(
                  {
                    type: "REPLY_CREATE_FAILED",
                    componentId: refComponentId.current,
                    passoverPayload: e.data.passoverPayload,
                  },
                  "*",
                );
              });
          }
        }
        break;
      }
      case "REPLY_UPDATE": {
        if (e.data.componentId === refComponentId.current) {
          const {
            channelId,
            parentId,
            replyId,
            content: payloadContent,
          } = e.data.payload;
          if (
            channelId &&
            parentId &&
            replyId &&
            Boolean(payloadContent?.length)
          ) {
            // updateReplyAction({
            //   type: "nestedReply",
            //   channelId,
            //   threadId: parentId,
            //   replyId,
            //   content: payloadContent,
            // });
          }
        }
        break;
      }
      case "REPLY_DELETE": {
        if (e.data.componentId === refComponentId.current) {
          const { channelId, replyId } = e.data.payload;
          if (channelId && replyId) {
            // deleteReplyAction({ forumId: channelId, threadId: replyId });
          }
        }
        break;
      }
      case "REPLY_VOTE": {
        if (e.data.componentId === refComponentId.current) {
          const { parentId, replyId, voteType } = e.data.payload;
          if (parentId && replyId && voteType) {
            // voteThreadAction({
            //   channelId: parentId,
            //   threadId: replyId,
            //   type: voteType,
            //   cancelToken: cancelToken.current.token,
            // });
          }
        }
        break;
      }
      case "THREAD_REPORT": {
        if (e.data.componentId === refComponentId.current) {
          const { threadId } = e.data.payload;
          if (threadId) {
            // openPostReport({
            //   threadId,
            // });
          }
        }
        break;
      }
      case "EMBED_PUSH_STATE": {
        if (e.data.componentId === refComponentId.current) {
          refHistoryChanged.current = true;
          history.pushState(
            {
              ...window.history.state,
              [e.data.componentId]: e.data.payload,
            },
            "",
          );
        }
        break;
      }

      case "EMBED_OPEN_SHARE_DIALOG": {
        if (e.data.componentId === refComponentId.current) {
          const { shareUrl, query } = e.data.payload as {
            shareUrl?: string;
            query?: string;
          };

          const combinedQuery = new URLSearchParams(location.search);
          if (query) {
            combinedQuery.set("sharedObject", query);
          }

          const targetUrl = new URL(
            shareUrl?.startsWith("http")
              ? shareUrl
              : `${location.origin}${location.pathname}${shareUrl}`,
          );
          targetUrl.search = combinedQuery.toString();

          // openShareDialog({
          //   shareData: {
          //     url: targetUrl.toString(),
          //   },
          // });
        }
        break;
      }

      default: {
        // console.log(">>>>>>>[parent] recv - unprocessable type", e.data);
        break;
      }
    }
  }, []);

  const handleLoad = React.useCallback(() => {
    postEvent.socketInstance?.on("new-message", payload => {
      ref.current?.contentWindow?.postMessage(
        { type: "new-message", payload },
        "*",
      );
    });
    postEvent.socketInstance?.on("updated-message", payload => {
      ref.current?.contentWindow?.postMessage(
        { type: "updated-message", payload },
        "*",
      );
    });
  }, [postEvent.socketInstance]);

  React.useEffect(() => {
    if (!content || didInit) return;

    console.time(">>>> parse & change");
    const htmlParser = new DOMParser();
    const doc = htmlParser.parseFromString(content, "text/html");

    const protocol = doc.createElement("script");
    protocol.type = "text/javascript";
    protocol.innerHTML = `
        window.__INIT_STATE__ = ${JSON.stringify({
          currentUser,
          authToken: accessToken,
          refreshToken,

          inApp: false,
          groupId: currentGroupId,
          channelId: MATCH_FORUM_ID,
          threadId: THREAD_ID,
          replyId: undefined,
          embedObject,

          sharedObject,
        })};
      `;
    doc.head.appendChild(protocol);

    css.forEach(src => {
      const style = doc.createElement("link");
      style.rel = "stylesheet";
      style.href = src;
      doc.head.appendChild(style);
    });

    script.forEach(src => {
      const sc = doc.createElement("script");
      sc.type = "module";
      sc.src = src;
      doc.head.appendChild(sc);
    });

    setHTML(doc.documentElement.outerHTML);
    console.timeEnd(">>>> parse & change");
    setDidInit(true);
  }, [content, didInit]);

  React.useEffect(() => {
    if (didInit) {
      window.addEventListener("message", recvMessage);

      return () => {
        window.removeEventListener("message", recvMessage);
        // closePostReport();
      };
    }
  }, [didInit]);

  return content ? (
    <Wrapper>
      <iframe
        ref={ref}
        style={{ border: "none" }}
        width="100%"
        height="100%"
        loading="eager"
        allow="*"
        sandbox="allow-modals allow-popups allow-same-origin allow-forms allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
        srcDoc={cHTML}
        onLoad={handleLoad}
      />
    </Wrapper>
  ) : (
    <div>....loading....</div>
  );
}
